import React, { memo, KeyboardEvent } from "react";
import styles from "./RadioButton.module.scss";
import { UseFormRegisterReturn } from "react-hook-form";
import { CheckedIcon } from "../../../../../assets/icons";

type Props = {
	initialValue: any;
	selectedValue: any;
	text?: string;
	imageUrl?: string;
	imageClass?: string;
	registerProp?: UseFormRegisterReturn<any>;
	onChangeValue: (value: any) => void;
};

const RadioButton: React.FC<Props> = memo((props: Props) => {
	const { initialValue, selectedValue, text, imageUrl, imageClass, registerProp, onChangeValue } = props;

	const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>, value: any) => {
		if (e.key === "Enter" || e.key === " ") {
			onChangeValue(value);
		}
	};

	return (
		<div className={styles.container}>
			{imageUrl ? (
				<div
					className={styles.radioButtonImgContainer}
					onKeyDown={e => handleKeyDown(e, selectedValue)}
					tabIndex={0}
					role="radio"
					aria-checked={selectedValue === initialValue}
					onClick={() => onChangeValue(selectedValue)}
				>
					{selectedValue === initialValue ? (
						<div className={styles.checkmark}>
							<CheckedIcon />
						</div>
					) : (
						<div className={styles.checkmark}>
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M9.99998 14.5C11.2487 14.5 12.3109 14.0621 13.1865 13.1865C14.0621 12.3109 14.5 11.2487 14.5 9.99998C14.5 8.75128 14.0621 7.6891 13.1865 6.81345C12.3109 5.93782 11.2487 5.5 9.99998 5.5C8.75128 5.5 7.6891 5.93782 6.81345 6.81345C5.93782 7.6891 5.5 8.75128 5.5 9.99998C5.5 11.2487 5.93782 12.3109 6.81345 13.1865C7.6891 14.0621 8.75128 14.5 9.99998 14.5ZM10.0016 19.5C8.68772 19.5 7.45268 19.2506 6.29655 18.752C5.1404 18.2533 4.13472 17.5765 3.2795 16.7217C2.42427 15.8669 1.74721 14.8616 1.24833 13.706C0.749442 12.5504 0.5 11.3156 0.5 10.0017C0.5 8.68772 0.749334 7.45268 1.248 6.29655C1.74667 5.1404 2.42342 4.13472 3.27825 3.2795C4.1331 2.42427 5.13834 1.74721 6.29398 1.24833C7.44959 0.749443 8.68437 0.5 9.9983 0.5C11.3122 0.5 12.5473 0.749334 13.7034 1.248C14.8596 1.74667 15.8652 2.42342 16.7205 3.27825C17.5757 4.1331 18.2527 5.13834 18.7516 6.29398C19.2505 7.44959 19.5 8.68437 19.5 9.9983C19.5 11.3122 19.2506 12.5473 18.752 13.7034C18.2533 14.8596 17.5765 15.8652 16.7217 16.7205C15.8669 17.5757 14.8616 18.2527 13.706 18.7516C12.5504 19.2505 11.3156 19.5 10.0016 19.5Z"
									fill="#2E3336"
									fillOpacity="0.2"
								/>
							</svg>
						</div>
					)}
					<img className={imageClass ?? ""} src={imageUrl} alt={text} />
					<div className={styles.text}>{text}</div>
					<input value={selectedValue} type="radio" {...registerProp} hidden />
				</div>
			) : (
				<div
					className={styles.radioButtonContainer}
					onClick={() => onChangeValue(selectedValue)}
					onKeyDown={e => handleKeyDown(e, selectedValue)}
					tabIndex={0}
					role="radio"
					aria-checked={selectedValue === initialValue}
				>
					<div className={styles.text}>{text}</div>
					{selectedValue === initialValue ? (
						<CheckedIcon />
					) : (
						<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M9.99998 14.5C11.2487 14.5 12.3109 14.0621 13.1865 13.1865C14.0621 12.3109 14.5 11.2487 14.5 9.99998C14.5 8.75128 14.0621 7.6891 13.1865 6.81345C12.3109 5.93782 11.2487 5.5 9.99998 5.5C8.75128 5.5 7.6891 5.93782 6.81345 6.81345C5.93782 7.6891 5.5 8.75128 5.5 9.99998C5.5 11.2487 5.93782 12.3109 6.81345 13.1865C7.6891 14.0621 8.75128 14.5 9.99998 14.5ZM10.0016 19.5C8.68772 19.5 7.45268 19.2506 6.29655 18.752C5.1404 18.2533 4.13472 17.5765 3.2795 16.7217C2.42427 15.8669 1.74721 14.8616 1.24833 13.706C0.749442 12.5504 0.5 11.3156 0.5 10.0017C0.5 8.68772 0.749334 7.45268 1.248 6.29655C1.74667 5.1404 2.42342 4.13472 3.27825 3.2795C4.1331 2.42427 5.13834 1.74721 6.29398 1.24833C7.44959 0.749443 8.68437 0.5 9.9983 0.5C11.3122 0.5 12.5473 0.749334 13.7034 1.248C14.8596 1.74667 15.8652 2.42342 16.7205 3.27825C17.5757 4.1331 18.2527 5.13834 18.7516 6.29398C19.2505 7.44959 19.5 8.68437 19.5 9.9983C19.5 11.3122 19.2506 12.5473 18.752 13.7034C18.2533 14.8596 17.5765 15.8652 16.7217 16.7205C15.8669 17.5757 14.8616 18.2527 13.706 18.7516C12.5504 19.2505 11.3156 19.5 10.0016 19.5Z"
								fill="#2E3336"
								fillOpacity="0.2"
							/>
						</svg>
					)}
					<input value={selectedValue} type="radio" {...registerProp} hidden />
				</div>
			)}
		</div>
	);
});

export default RadioButton;
